import React from "react";

const WhyBecomeSeller = () => {
  return (
    <section className='why-seller py-80'>
      <div className='container'>
        <div className='section-heading text-center mx-auto wow fadeInUp' data-wow-duration="0.7s">
          <h5 className=''>Why become a seller on Healthy Homes?</h5>
          <span className='text-gray-600'>
            Join our network of trusted producers and natural goods artisans.
          </span>
        </div>
        <div className='row gy-4 justify-content-center'>
          <div className='col-lg-4 col-sm-6 wow fadeInUp' data-wow-delay="0.1s">
            <div className='why-seller-item text-center hover-lift p-24 rounded-16 bg-white border border-gray-100'>
              <span className='text-main-600 text-72 d-inline-flex'>
                <i className='ph ph-gift' />
              </span>
              <h6 className='my-28'>Free Shipping Support</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Connect with thousands of loyal customers who value authentic, chemical-free products.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6 wow fadeInUp' data-wow-delay="0.2s">
            <div className='why-seller-item text-center hover-lift p-24 rounded-16 bg-white border border-gray-100'>
              <span className='text-main-600 text-72 d-inline-flex'>
                <i className='ph ph-credit-card' />
              </span>
              <h6 className='my-28'>Flexible Payouts</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Fast, transparent settlements directly into your account with zero hidden fees.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6 wow fadeInUp' data-wow-delay="0.3s">
            <div className='why-seller-item text-center hover-lift p-24 rounded-16 bg-white border border-gray-100'>
              <span className='text-main-600 text-72 d-inline-flex'>
                <i className='ph ph-chats' />
              </span>
              <h6 className='my-28'>Dedicated Support</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Our seller success team is here to assist you with onboarding, listings, and promotions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyBecomeSeller;
